var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction"},[(!_vm.pc)?_c('div',{staticClass:"m"},[_c('topM',{attrs:{"lang":_vm.lang}})],1):_c('div',{staticClass:"pc"},[_c('topPc')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }